import React from 'react'
import GroupList from '_pages/Group/GroupList'

function ListMyGroupsPage() {
  return <GroupList />
}

export default ListMyGroupsPage
